import { ComparisonModal } from "./ComparisonModal";

export default ComparisonModal;